<template>
  <v-dialog v-model="isServedDialog" :persistent="false" max-width="400">
    <v-card elevation="2">
      <div role="contentinfo">
        <v-img
          :src="
            servedShopSettings.img || require('@/assets/images/no-photo.svg')
          "
        ></v-img>
      </div>
      <div class="icon-window-close">
        <v-icon @click.capture="closeDialog()">
          {{ icons.mdiWindowClose }}
        </v-icon>
      </div>
      <v-card-text
        class="text-center dialog-card-text dark--text mt-4"
        v-html="servedShopSettings.msg"
        v-if="servedShopSettings && servedShopSettings.msg"
      >
        >
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { makeHydrationDialog } from '@/mixins/dialogMixin'
export default {
  name: 'isServedDialog',
  data: () => ({
    isServedDialog: false,
  }),
  mixins: [makeHydrationDialog()],
  methods: {
    closeDialog() {
      if (this.isServedDialog) {
        this.$set(this, this.$options.name, false)
      }
    },
  },
  mounted() {
    if (!this.servedShopSettings?.disabled)
      this.$set(this, this.$options.name, true)
  },
}
</script>

<style></style>
